import LayoutInside from "@/layout/LayoutInside";
import { useTranslation } from "react-i18next";
import PlatformReferralsTab from "../Reports/PartnerCommissions/Tabs/PlatformReferralsTab";

const ReferAndEarn = () => {
  const { t } = useTranslation("referAndEarn");

  return (
    <LayoutInside items={[{ text: t("title"), link: "/refer-and-earn" }]}>
      <PlatformReferralsTab />
    </LayoutInside>
  );
};

export default ReferAndEarn;